function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M31.567 9c-2.448 0-4.432-2.015-4.432-4.5S29.119 0 31.567 0C34.016 0 36 2.015 36 4.5S34.016 9 31.567 9zM18 9c-2.447 0-4.431-2.015-4.431-4.5S15.553 0 18 0s4.431 2.015 4.431 4.5S20.447 9 18 9zM4.433 9C1.984 9 0 6.985 0 4.5S1.984 0 4.433 0c2.448 0 4.432 2.015 4.432 4.5S6.881 9 4.433 9z",
  fillRule: "evenodd"
});

var SvgMore = function SvgMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 36 9"
  }, props), _ref);
};

export default SvgMore;